<template>
  <PageArticleListCategory
    :category="category"
    :init-articles="articles"
    :init-page="page"
    :init-per-page="perPage"
    :menu-item="menuItem"
    :total="total"
  />
</template>

<script>
import { get } from 'lodash'
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageArticleListCategory from '@theme/components/content/PageArticleListCategory'

const PAGE = {
  name: 'RouteArticleListCategory',
  nuxtI18n: {
    paths: {
      cs: '/clanky/:slug',
      de: '/artikel/:slug',
      en: '/articles/:slug',
      sk: '/clanky/:slug',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageArticleListCategory,
  },
  mixins: [AppRouteMixin],
  async asyncData({ app, store, params, query, redirect, req, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }

    // Handle duplicates
    if (query.p === '0') {
      delete query.p
      redirect(301, req.path, query)
      return
    }

    const page = Number(query.p) > 0 ? Number(query.p) : 0
    const perPage = app.$themeSettings.components.ArticleList.perPage
    const categorySlug = params.slug

    const category = await store.dispatch('article/LOAD_CATEGORY', { categorySlug })

    if (!category) {
      return app.$pageNotFound({ slug: params.slug })
    }

    const parentSlug = get(category, 'master_category[0].entity.page_meta.slug')
    if (parentSlug) {
      const path = app.localePath({ name: 'articleList-slug-child', params: { slug: parentSlug, child: params.slug } })
      redirect(301, path, query)
      return
    }

    const { articles, total } = await store.dispatch('article/LOAD_CATEGORY_ARTICLES', {
      categoryId: category._id,
      page,
      perPage,
    })
    store.commit('locale/SET_CANONICALS', {
      canonicalSlugs: get(category, 'page_meta.canonical_slugs', []),
    })
    await store.dispatch('article/LOAD_HEADER_CONFIGURATION')
    await store.dispatch('menu/FETCH_MENU', 'article')
    await store.dispatch('article/FETCH_CATEGORIES')
    await store.dispatch('article/FETCH_TAGS')
    return {
      articles,
      category: category,
      page,
      perPage,
      total: total || 0,
      menuItem: await store
        .dispatch('menu/FIND_MENU_ITEMS', { ids: [category._id], menu: 'article' })
        .then(items => items[0]),
    }
  },
}
export default PAGE
</script>
